/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnswerControlOfferRequest,
  AssignMissionControlRequest,
  AwardKnightRequest,
  CastVoteRequest,
  CloseMissionRequest,
  CommitteeQueueItemDtoPagedList,
  CommitteeVoteResult,
  CoverageDto,
  CreateSubMissionCommand,
  CreditParticipationRequest,
  ExcludeMemberRequest,
  GetApiV1MissionsBoardParams,
  GetApiV1MissionsCommitteeQueueParams,
  GetApiV1MissionsMissionIdCoverageParams,
  GetApiV1MissionsParams,
  HandOverMissionControlRequest,
  MemberPositionDto,
  MissionBundleDto,
  MissionControlDto,
  MissionDetailDto,
  MissionHealthFlagDto,
  MissionIntakeDto,
  MissionListItemDtoPagedList,
  MissionRosterEntryDto,
  MyReportDto,
  MySosDto,
  NameMissionLeaderRequest,
  ProblemDetails,
  PublishMissionRequest,
  RefuseMissionRequest,
  RemoveMissionMemberRequest,
  ReportFoundRequest,
  ReportMissingPersonCommand,
  ReportStrandedCommand,
  ReportStrandedOnBehalfCommand,
  RestrictedMissingReportDto,
  SetRallyPointRequest,
  StartRoundRequest,
  SubmitToCommitteeRequest,
  TrackBatchRequest,
  TrackBatchResult,
  ValidationProblemDetails,
  WriteMissionReportRequest,
  WriteRoundReportRequest
} from '.././model';

import { request } from '../../http-client';




export const getApiV1Missions = (
    params?: GetApiV1MissionsParams,
 signal?: AbortSignal
) => {
      
      
      return request<MissionListItemDtoPagedList>(
      {url: `/api/v1/missions`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1MissionsQueryKey = (params?: GetApiV1MissionsParams,) => {
    return [
    `/api/v1/missions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1MissionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Missions>>, TError = unknown>(params?: GetApiV1MissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Missions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Missions>>> = ({ signal }) => getApiV1Missions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Missions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Missions>>>
export type GetApiV1MissionsQueryError = unknown


export function useGetApiV1Missions<TData = Awaited<ReturnType<typeof getApiV1Missions>>, TError = unknown>(
 params: undefined |  GetApiV1MissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Missions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Missions>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Missions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Missions<TData = Awaited<ReturnType<typeof getApiV1Missions>>, TError = unknown>(
 params?: GetApiV1MissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Missions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Missions>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Missions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Missions<TData = Awaited<ReturnType<typeof getApiV1Missions>>, TError = unknown>(
 params?: GetApiV1MissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Missions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Missions<TData = Awaited<ReturnType<typeof getApiV1Missions>>, TError = unknown>(
 params?: GetApiV1MissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Missions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1MissionsMineReports = (
    
 signal?: AbortSignal
) => {
      
      
      return request<MyReportDto[]>(
      {url: `/api/v1/missions/mine/reports`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MissionsMineReportsQueryKey = () => {
    return [
    `/api/v1/missions/mine/reports`
    ] as const;
    }

    
export const getGetApiV1MissionsMineReportsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMineReports>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMineReports>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMineReportsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMineReports>>> = ({ signal }) => getApiV1MissionsMineReports(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMineReports>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMineReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMineReports>>>
export type GetApiV1MissionsMineReportsQueryError = unknown


export function useGetApiV1MissionsMineReports<TData = Awaited<ReturnType<typeof getApiV1MissionsMineReports>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMineReports>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMineReports>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMineReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMineReports<TData = Awaited<ReturnType<typeof getApiV1MissionsMineReports>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMineReports>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMineReports>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMineReports>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMineReports<TData = Awaited<ReturnType<typeof getApiV1MissionsMineReports>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMineReports>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMineReports<TData = Awaited<ReturnType<typeof getApiV1MissionsMineReports>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMineReports>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMineReportsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1MissionsMySos = (
    
 signal?: AbortSignal
) => {
      
      
      return request<MySosDto | void>(
      {url: `/api/v1/missions/my-sos`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MissionsMySosQueryKey = () => {
    return [
    `/api/v1/missions/my-sos`
    ] as const;
    }

    
export const getGetApiV1MissionsMySosQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMySos>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMySos>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMySosQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMySos>>> = ({ signal }) => getApiV1MissionsMySos(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMySos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMySosQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMySos>>>
export type GetApiV1MissionsMySosQueryError = unknown


export function useGetApiV1MissionsMySos<TData = Awaited<ReturnType<typeof getApiV1MissionsMySos>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMySos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMySos>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMySos>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMySos<TData = Awaited<ReturnType<typeof getApiV1MissionsMySos>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMySos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMySos>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMySos>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMySos<TData = Awaited<ReturnType<typeof getApiV1MissionsMySos>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMySos>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMySos<TData = Awaited<ReturnType<typeof getApiV1MissionsMySos>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMySos>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMySosQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1MissionsBoard = (
    params?: GetApiV1MissionsBoardParams,
 signal?: AbortSignal
) => {
      
      
      return request<MissionListItemDtoPagedList>(
      {url: `/api/v1/missions/board`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1MissionsBoardQueryKey = (params?: GetApiV1MissionsBoardParams,) => {
    return [
    `/api/v1/missions/board`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1MissionsBoardQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsBoard>>, TError = ProblemDetails>(params?: GetApiV1MissionsBoardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsBoard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsBoardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsBoard>>> = ({ signal }) => getApiV1MissionsBoard(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsBoard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsBoardQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsBoard>>>
export type GetApiV1MissionsBoardQueryError = ProblemDetails


export function useGetApiV1MissionsBoard<TData = Awaited<ReturnType<typeof getApiV1MissionsBoard>>, TError = ProblemDetails>(
 params: undefined |  GetApiV1MissionsBoardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsBoard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsBoard>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsBoard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsBoard<TData = Awaited<ReturnType<typeof getApiV1MissionsBoard>>, TError = ProblemDetails>(
 params?: GetApiV1MissionsBoardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsBoard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsBoard>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsBoard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsBoard<TData = Awaited<ReturnType<typeof getApiV1MissionsBoard>>, TError = ProblemDetails>(
 params?: GetApiV1MissionsBoardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsBoard>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsBoard<TData = Awaited<ReturnType<typeof getApiV1MissionsBoard>>, TError = ProblemDetails>(
 params?: GetApiV1MissionsBoardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsBoard>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsBoardQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1MissionsMissionId = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<MissionDetailDto>(
      {url: `/api/v1/missions/${missionId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MissionsMissionIdQueryKey = (missionId?: string,) => {
    return [
    `/api/v1/missions/${missionId}`
    ] as const;
    }

    
export const getGetApiV1MissionsMissionIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMissionId>>, TError = ProblemDetails>(missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMissionIdQueryKey(missionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMissionId>>> = ({ signal }) => getApiV1MissionsMissionId(missionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(missionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMissionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMissionId>>>
export type GetApiV1MissionsMissionIdQueryError = ProblemDetails


export function useGetApiV1MissionsMissionId<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionId>>, TError = ProblemDetails>(
 missionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionId<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionId>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionId>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionId<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionId>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMissionId<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionId>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMissionIdQueryOptions(missionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1MissionsMissionIdHealthFlag = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<MissionHealthFlagDto>(
      {url: `/api/v1/missions/${missionId}/health-flag`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MissionsMissionIdHealthFlagQueryKey = (missionId?: string,) => {
    return [
    `/api/v1/missions/${missionId}/health-flag`
    ] as const;
    }

    
export const getGetApiV1MissionsMissionIdHealthFlagQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>, TError = ProblemDetails>(missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMissionIdHealthFlagQueryKey(missionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>> = ({ signal }) => getApiV1MissionsMissionIdHealthFlag(missionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(missionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMissionIdHealthFlagQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>>
export type GetApiV1MissionsMissionIdHealthFlagQueryError = ProblemDetails


export function useGetApiV1MissionsMissionIdHealthFlag<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>, TError = ProblemDetails>(
 missionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdHealthFlag<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdHealthFlag<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMissionIdHealthFlag<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdHealthFlag>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMissionIdHealthFlagQueryOptions(missionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1MissionsMissionIdIntake = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<MissionIntakeDto>(
      {url: `/api/v1/missions/${missionId}/intake`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MissionsMissionIdIntakeQueryKey = (missionId?: string,) => {
    return [
    `/api/v1/missions/${missionId}/intake`
    ] as const;
    }

    
export const getGetApiV1MissionsMissionIdIntakeQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>, TError = ProblemDetails>(missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMissionIdIntakeQueryKey(missionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>> = ({ signal }) => getApiV1MissionsMissionIdIntake(missionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(missionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMissionIdIntakeQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>>
export type GetApiV1MissionsMissionIdIntakeQueryError = ProblemDetails


export function useGetApiV1MissionsMissionIdIntake<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>, TError = ProblemDetails>(
 missionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdIntake<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdIntake<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMissionIdIntake<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdIntake>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMissionIdIntakeQueryOptions(missionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1MissionsMissionIdRestrictedReport = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<RestrictedMissingReportDto>(
      {url: `/api/v1/missions/${missionId}/restricted-report`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MissionsMissionIdRestrictedReportQueryKey = (missionId?: string,) => {
    return [
    `/api/v1/missions/${missionId}/restricted-report`
    ] as const;
    }

    
export const getGetApiV1MissionsMissionIdRestrictedReportQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>, TError = ProblemDetails>(missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMissionIdRestrictedReportQueryKey(missionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>> = ({ signal }) => getApiV1MissionsMissionIdRestrictedReport(missionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(missionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMissionIdRestrictedReportQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>>
export type GetApiV1MissionsMissionIdRestrictedReportQueryError = ProblemDetails


export function useGetApiV1MissionsMissionIdRestrictedReport<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>, TError = ProblemDetails>(
 missionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdRestrictedReport<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdRestrictedReport<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMissionIdRestrictedReport<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdRestrictedReport>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMissionIdRestrictedReportQueryOptions(missionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiV1MissionsMissionIdClose = (
    missionId: string,
    closeMissionRequest: CloseMissionRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/close`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: closeMissionRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdCloseMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdClose>>, TError,{missionId: string;data: CloseMissionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdClose>>, TError,{missionId: string;data: CloseMissionRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdClose'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdClose>>, {missionId: string;data: CloseMissionRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdClose(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdCloseMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdClose>>>
    export type PostApiV1MissionsMissionIdCloseMutationBody = CloseMissionRequest
    export type PostApiV1MissionsMissionIdCloseMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdClose = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdClose>>, TError,{missionId: string;data: CloseMissionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdClose>>,
        TError,
        {missionId: string;data: CloseMissionRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdCloseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putApiV1MissionsMissionIdReport = (
    missionId: string,
    writeMissionReportRequest: WriteMissionReportRequest,
 ) => {
      
      
      return request<string>(
      {url: `/api/v1/missions/${missionId}/report`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: writeMissionReportRequest
    },
      );
    }
  


export const getPutApiV1MissionsMissionIdReportMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1MissionsMissionIdReport>>, TError,{missionId: string;data: WriteMissionReportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1MissionsMissionIdReport>>, TError,{missionId: string;data: WriteMissionReportRequest}, TContext> => {

const mutationKey = ['putApiV1MissionsMissionIdReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1MissionsMissionIdReport>>, {missionId: string;data: WriteMissionReportRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  putApiV1MissionsMissionIdReport(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1MissionsMissionIdReportMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1MissionsMissionIdReport>>>
    export type PutApiV1MissionsMissionIdReportMutationBody = WriteMissionReportRequest
    export type PutApiV1MissionsMissionIdReportMutationError = ValidationProblemDetails | ProblemDetails

    export const usePutApiV1MissionsMissionIdReport = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1MissionsMissionIdReport>>, TError,{missionId: string;data: WriteMissionReportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1MissionsMissionIdReport>>,
        TError,
        {missionId: string;data: WriteMissionReportRequest},
        TContext
      > => {

      const mutationOptions = getPutApiV1MissionsMissionIdReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdReportApprove = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/report/approve`, method: 'POST', signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdReportApproveMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdReportApprove>>, TError,{missionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdReportApprove>>, TError,{missionId: string}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdReportApprove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdReportApprove>>, {missionId: string}> = (props) => {
          const {missionId} = props ?? {};

          return  postApiV1MissionsMissionIdReportApprove(missionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdReportApproveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdReportApprove>>>
    
    export type PostApiV1MissionsMissionIdReportApproveMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdReportApprove = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdReportApprove>>, TError,{missionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdReportApprove>>,
        TError,
        {missionId: string},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdReportApproveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1MissionsMissionIdReportFile = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/api/v1/missions/${missionId}/report/file`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MissionsMissionIdReportFileQueryKey = (missionId?: string,) => {
    return [
    `/api/v1/missions/${missionId}/report/file`
    ] as const;
    }

    
export const getGetApiV1MissionsMissionIdReportFileQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>, TError = ProblemDetails>(missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMissionIdReportFileQueryKey(missionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>> = ({ signal }) => getApiV1MissionsMissionIdReportFile(missionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(missionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMissionIdReportFileQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>>
export type GetApiV1MissionsMissionIdReportFileQueryError = ProblemDetails


export function useGetApiV1MissionsMissionIdReportFile<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>, TError = ProblemDetails>(
 missionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdReportFile<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdReportFile<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMissionIdReportFile<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdReportFile>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMissionIdReportFileQueryOptions(missionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiV1MissionsMissionIdMembersMembershipIdParticipation = (
    missionId: string,
    membershipId: string,
    creditParticipationRequest: CreditParticipationRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/members/${membershipId}/participation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: creditParticipationRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdMembersMembershipIdParticipationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdParticipation>>, TError,{missionId: string;membershipId: string;data: CreditParticipationRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdParticipation>>, TError,{missionId: string;membershipId: string;data: CreditParticipationRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdMembersMembershipIdParticipation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdParticipation>>, {missionId: string;membershipId: string;data: CreditParticipationRequest}> = (props) => {
          const {missionId,membershipId,data} = props ?? {};

          return  postApiV1MissionsMissionIdMembersMembershipIdParticipation(missionId,membershipId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdMembersMembershipIdParticipationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdParticipation>>>
    export type PostApiV1MissionsMissionIdMembersMembershipIdParticipationMutationBody = CreditParticipationRequest
    export type PostApiV1MissionsMissionIdMembersMembershipIdParticipationMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdMembersMembershipIdParticipation = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdParticipation>>, TError,{missionId: string;membershipId: string;data: CreditParticipationRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdParticipation>>,
        TError,
        {missionId: string;membershipId: string;data: CreditParticipationRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdMembersMembershipIdParticipationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdMembersMembershipIdReinstate = (
    missionId: string,
    membershipId: string,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/members/${membershipId}/reinstate`, method: 'POST', signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdMembersMembershipIdReinstateMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdReinstate>>, TError,{missionId: string;membershipId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdReinstate>>, TError,{missionId: string;membershipId: string}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdMembersMembershipIdReinstate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdReinstate>>, {missionId: string;membershipId: string}> = (props) => {
          const {missionId,membershipId} = props ?? {};

          return  postApiV1MissionsMissionIdMembersMembershipIdReinstate(missionId,membershipId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdMembersMembershipIdReinstateMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdReinstate>>>
    
    export type PostApiV1MissionsMissionIdMembersMembershipIdReinstateMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdMembersMembershipIdReinstate = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdReinstate>>, TError,{missionId: string;membershipId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdReinstate>>,
        TError,
        {missionId: string;membershipId: string},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdMembersMembershipIdReinstateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdMembersMembershipIdKnight = (
    missionId: string,
    membershipId: string,
    awardKnightRequest: AwardKnightRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/members/${membershipId}/knight`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: awardKnightRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdMembersMembershipIdKnightMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdKnight>>, TError,{missionId: string;membershipId: string;data: AwardKnightRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdKnight>>, TError,{missionId: string;membershipId: string;data: AwardKnightRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdMembersMembershipIdKnight'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdKnight>>, {missionId: string;membershipId: string;data: AwardKnightRequest}> = (props) => {
          const {missionId,membershipId,data} = props ?? {};

          return  postApiV1MissionsMissionIdMembersMembershipIdKnight(missionId,membershipId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdMembersMembershipIdKnightMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdKnight>>>
    export type PostApiV1MissionsMissionIdMembersMembershipIdKnightMutationBody = AwardKnightRequest
    export type PostApiV1MissionsMissionIdMembersMembershipIdKnightMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdMembersMembershipIdKnight = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdKnight>>, TError,{missionId: string;membershipId: string;data: AwardKnightRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdKnight>>,
        TError,
        {missionId: string;membershipId: string;data: AwardKnightRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdMembersMembershipIdKnightMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdControlAnswer = (
    missionId: string,
    answerControlOfferRequest: AnswerControlOfferRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/control/answer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: answerControlOfferRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdControlAnswerMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlAnswer>>, TError,{missionId: string;data: AnswerControlOfferRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlAnswer>>, TError,{missionId: string;data: AnswerControlOfferRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdControlAnswer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlAnswer>>, {missionId: string;data: AnswerControlOfferRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdControlAnswer(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdControlAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlAnswer>>>
    export type PostApiV1MissionsMissionIdControlAnswerMutationBody = AnswerControlOfferRequest
    export type PostApiV1MissionsMissionIdControlAnswerMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdControlAnswer = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlAnswer>>, TError,{missionId: string;data: AnswerControlOfferRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlAnswer>>,
        TError,
        {missionId: string;data: AnswerControlOfferRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdControlAnswerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1MissionsMissionIdControl = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<MissionControlDto>(
      {url: `/api/v1/missions/${missionId}/control`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MissionsMissionIdControlQueryKey = (missionId?: string,) => {
    return [
    `/api/v1/missions/${missionId}/control`
    ] as const;
    }

    
export const getGetApiV1MissionsMissionIdControlQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>, TError = ProblemDetails>(missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMissionIdControlQueryKey(missionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>> = ({ signal }) => getApiV1MissionsMissionIdControl(missionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(missionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMissionIdControlQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>>
export type GetApiV1MissionsMissionIdControlQueryError = ProblemDetails


export function useGetApiV1MissionsMissionIdControl<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>, TError = ProblemDetails>(
 missionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdControl<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdControl<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMissionIdControl<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdControl>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMissionIdControlQueryOptions(missionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiV1MissionsMissionIdControl = (
    missionId: string,
    assignMissionControlRequest: AssignMissionControlRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/control`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assignMissionControlRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdControlMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControl>>, TError,{missionId: string;data: AssignMissionControlRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControl>>, TError,{missionId: string;data: AssignMissionControlRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdControl'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControl>>, {missionId: string;data: AssignMissionControlRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdControl(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdControlMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControl>>>
    export type PostApiV1MissionsMissionIdControlMutationBody = AssignMissionControlRequest
    export type PostApiV1MissionsMissionIdControlMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdControl = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControl>>, TError,{missionId: string;data: AssignMissionControlRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdControl>>,
        TError,
        {missionId: string;data: AssignMissionControlRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdControlMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdControlHandover = (
    missionId: string,
    handOverMissionControlRequest: HandOverMissionControlRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/control/handover`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: handOverMissionControlRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdControlHandoverMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlHandover>>, TError,{missionId: string;data: HandOverMissionControlRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlHandover>>, TError,{missionId: string;data: HandOverMissionControlRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdControlHandover'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlHandover>>, {missionId: string;data: HandOverMissionControlRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdControlHandover(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdControlHandoverMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlHandover>>>
    export type PostApiV1MissionsMissionIdControlHandoverMutationBody = HandOverMissionControlRequest
    export type PostApiV1MissionsMissionIdControlHandoverMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdControlHandover = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlHandover>>, TError,{missionId: string;data: HandOverMissionControlRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdControlHandover>>,
        TError,
        {missionId: string;data: HandOverMissionControlRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdControlHandoverMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdMembersMembershipIdRemove = (
    missionId: string,
    membershipId: string,
    removeMissionMemberRequest: RemoveMissionMemberRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/members/${membershipId}/remove`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: removeMissionMemberRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdMembersMembershipIdRemoveMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdRemove>>, TError,{missionId: string;membershipId: string;data: RemoveMissionMemberRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdRemove>>, TError,{missionId: string;membershipId: string;data: RemoveMissionMemberRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdMembersMembershipIdRemove'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdRemove>>, {missionId: string;membershipId: string;data: RemoveMissionMemberRequest}> = (props) => {
          const {missionId,membershipId,data} = props ?? {};

          return  postApiV1MissionsMissionIdMembersMembershipIdRemove(missionId,membershipId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdMembersMembershipIdRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdRemove>>>
    export type PostApiV1MissionsMissionIdMembersMembershipIdRemoveMutationBody = RemoveMissionMemberRequest
    export type PostApiV1MissionsMissionIdMembersMembershipIdRemoveMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MissionsMissionIdMembersMembershipIdRemove = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdRemove>>, TError,{missionId: string;membershipId: string;data: RemoveMissionMemberRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdRemove>>,
        TError,
        {missionId: string;membershipId: string;data: RemoveMissionMemberRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdMembersMembershipIdRemoveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdMembersMembershipIdLeader = (
    missionId: string,
    membershipId: string,
    nameMissionLeaderRequest: NameMissionLeaderRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/members/${membershipId}/leader`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: nameMissionLeaderRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdMembersMembershipIdLeaderMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdLeader>>, TError,{missionId: string;membershipId: string;data: NameMissionLeaderRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdLeader>>, TError,{missionId: string;membershipId: string;data: NameMissionLeaderRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdMembersMembershipIdLeader'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdLeader>>, {missionId: string;membershipId: string;data: NameMissionLeaderRequest}> = (props) => {
          const {missionId,membershipId,data} = props ?? {};

          return  postApiV1MissionsMissionIdMembersMembershipIdLeader(missionId,membershipId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdMembersMembershipIdLeaderMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdLeader>>>
    export type PostApiV1MissionsMissionIdMembersMembershipIdLeaderMutationBody = NameMissionLeaderRequest
    export type PostApiV1MissionsMissionIdMembersMembershipIdLeaderMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdMembersMembershipIdLeader = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdLeader>>, TError,{missionId: string;membershipId: string;data: NameMissionLeaderRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdLeader>>,
        TError,
        {missionId: string;membershipId: string;data: NameMissionLeaderRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdMembersMembershipIdLeaderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putApiV1MissionsMissionIdRallyPoint = (
    missionId: string,
    setRallyPointRequest: SetRallyPointRequest,
 ) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/rally-point`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setRallyPointRequest
    },
      );
    }
  


export const getPutApiV1MissionsMissionIdRallyPointMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1MissionsMissionIdRallyPoint>>, TError,{missionId: string;data: SetRallyPointRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1MissionsMissionIdRallyPoint>>, TError,{missionId: string;data: SetRallyPointRequest}, TContext> => {

const mutationKey = ['putApiV1MissionsMissionIdRallyPoint'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1MissionsMissionIdRallyPoint>>, {missionId: string;data: SetRallyPointRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  putApiV1MissionsMissionIdRallyPoint(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1MissionsMissionIdRallyPointMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1MissionsMissionIdRallyPoint>>>
    export type PutApiV1MissionsMissionIdRallyPointMutationBody = SetRallyPointRequest
    export type PutApiV1MissionsMissionIdRallyPointMutationError = ValidationProblemDetails | ProblemDetails

    export const usePutApiV1MissionsMissionIdRallyPoint = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1MissionsMissionIdRallyPoint>>, TError,{missionId: string;data: SetRallyPointRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1MissionsMissionIdRallyPoint>>,
        TError,
        {missionId: string;data: SetRallyPointRequest},
        TContext
      > => {

      const mutationOptions = getPutApiV1MissionsMissionIdRallyPointMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdFound = (
    missionId: string,
    reportFoundRequest: ReportFoundRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/found`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportFoundRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdFoundMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdFound>>, TError,{missionId: string;data: ReportFoundRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdFound>>, TError,{missionId: string;data: ReportFoundRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdFound'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdFound>>, {missionId: string;data: ReportFoundRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdFound(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdFoundMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdFound>>>
    export type PostApiV1MissionsMissionIdFoundMutationBody = ReportFoundRequest
    export type PostApiV1MissionsMissionIdFoundMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MissionsMissionIdFound = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdFound>>, TError,{missionId: string;data: ReportFoundRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdFound>>,
        TError,
        {missionId: string;data: ReportFoundRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdFoundMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdRounds = (
    missionId: string,
    startRoundRequest: StartRoundRequest,
 signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/api/v1/missions/${missionId}/rounds`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: startRoundRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdRoundsMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRounds>>, TError,{missionId: string;data: StartRoundRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRounds>>, TError,{missionId: string;data: StartRoundRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdRounds'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRounds>>, {missionId: string;data: StartRoundRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdRounds(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdRoundsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRounds>>>
    export type PostApiV1MissionsMissionIdRoundsMutationBody = StartRoundRequest
    export type PostApiV1MissionsMissionIdRoundsMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MissionsMissionIdRounds = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRounds>>, TError,{missionId: string;data: StartRoundRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdRounds>>,
        TError,
        {missionId: string;data: StartRoundRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdRoundsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdRoundsCurrentEnd = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/rounds/current/end`, method: 'POST', signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdRoundsCurrentEndMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRoundsCurrentEnd>>, TError,{missionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRoundsCurrentEnd>>, TError,{missionId: string}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdRoundsCurrentEnd'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRoundsCurrentEnd>>, {missionId: string}> = (props) => {
          const {missionId} = props ?? {};

          return  postApiV1MissionsMissionIdRoundsCurrentEnd(missionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdRoundsCurrentEndMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRoundsCurrentEnd>>>
    
    export type PostApiV1MissionsMissionIdRoundsCurrentEndMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdRoundsCurrentEnd = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRoundsCurrentEnd>>, TError,{missionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdRoundsCurrentEnd>>,
        TError,
        {missionId: string},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdRoundsCurrentEndMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putApiV1MissionsMissionIdRoundsRoundIdReport = (
    missionId: string,
    roundId: string,
    writeRoundReportRequest: WriteRoundReportRequest,
 ) => {
      
      
      return request<string>(
      {url: `/api/v1/missions/${missionId}/rounds/${roundId}/report`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: writeRoundReportRequest
    },
      );
    }
  


export const getPutApiV1MissionsMissionIdRoundsRoundIdReportMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1MissionsMissionIdRoundsRoundIdReport>>, TError,{missionId: string;roundId: string;data: WriteRoundReportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiV1MissionsMissionIdRoundsRoundIdReport>>, TError,{missionId: string;roundId: string;data: WriteRoundReportRequest}, TContext> => {

const mutationKey = ['putApiV1MissionsMissionIdRoundsRoundIdReport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiV1MissionsMissionIdRoundsRoundIdReport>>, {missionId: string;roundId: string;data: WriteRoundReportRequest}> = (props) => {
          const {missionId,roundId,data} = props ?? {};

          return  putApiV1MissionsMissionIdRoundsRoundIdReport(missionId,roundId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiV1MissionsMissionIdRoundsRoundIdReportMutationResult = NonNullable<Awaited<ReturnType<typeof putApiV1MissionsMissionIdRoundsRoundIdReport>>>
    export type PutApiV1MissionsMissionIdRoundsRoundIdReportMutationBody = WriteRoundReportRequest
    export type PutApiV1MissionsMissionIdRoundsRoundIdReportMutationError = ValidationProblemDetails | ProblemDetails

    export const usePutApiV1MissionsMissionIdRoundsRoundIdReport = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiV1MissionsMissionIdRoundsRoundIdReport>>, TError,{missionId: string;roundId: string;data: WriteRoundReportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiV1MissionsMissionIdRoundsRoundIdReport>>,
        TError,
        {missionId: string;roundId: string;data: WriteRoundReportRequest},
        TContext
      > => {

      const mutationOptions = getPutApiV1MissionsMissionIdRoundsRoundIdReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsStranded = (
    reportStrandedCommand: ReportStrandedCommand,
 signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/api/v1/missions/stranded`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportStrandedCommand, signal
    },
      );
    }
  


export const getPostApiV1MissionsStrandedMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsStranded>>, TError,{data: ReportStrandedCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsStranded>>, TError,{data: ReportStrandedCommand}, TContext> => {

const mutationKey = ['postApiV1MissionsStranded'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsStranded>>, {data: ReportStrandedCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1MissionsStranded(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsStrandedMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsStranded>>>
    export type PostApiV1MissionsStrandedMutationBody = ReportStrandedCommand
    export type PostApiV1MissionsStrandedMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MissionsStranded = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsStranded>>, TError,{data: ReportStrandedCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsStranded>>,
        TError,
        {data: ReportStrandedCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsStrandedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsStrandedOnBehalf = (
    reportStrandedOnBehalfCommand: ReportStrandedOnBehalfCommand,
 signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/api/v1/missions/stranded/on-behalf`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportStrandedOnBehalfCommand, signal
    },
      );
    }
  


export const getPostApiV1MissionsStrandedOnBehalfMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsStrandedOnBehalf>>, TError,{data: ReportStrandedOnBehalfCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsStrandedOnBehalf>>, TError,{data: ReportStrandedOnBehalfCommand}, TContext> => {

const mutationKey = ['postApiV1MissionsStrandedOnBehalf'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsStrandedOnBehalf>>, {data: ReportStrandedOnBehalfCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1MissionsStrandedOnBehalf(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsStrandedOnBehalfMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsStrandedOnBehalf>>>
    export type PostApiV1MissionsStrandedOnBehalfMutationBody = ReportStrandedOnBehalfCommand
    export type PostApiV1MissionsStrandedOnBehalfMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MissionsStrandedOnBehalf = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsStrandedOnBehalf>>, TError,{data: ReportStrandedOnBehalfCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsStrandedOnBehalf>>,
        TError,
        {data: ReportStrandedOnBehalfCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsStrandedOnBehalfMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsSubMissions = (
    createSubMissionCommand: CreateSubMissionCommand,
 signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/api/v1/missions/sub-missions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSubMissionCommand, signal
    },
      );
    }
  


export const getPostApiV1MissionsSubMissionsMutationOptions = <TError = ValidationProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsSubMissions>>, TError,{data: CreateSubMissionCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsSubMissions>>, TError,{data: CreateSubMissionCommand}, TContext> => {

const mutationKey = ['postApiV1MissionsSubMissions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsSubMissions>>, {data: CreateSubMissionCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1MissionsSubMissions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsSubMissionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsSubMissions>>>
    export type PostApiV1MissionsSubMissionsMutationBody = CreateSubMissionCommand
    export type PostApiV1MissionsSubMissionsMutationError = ValidationProblemDetails

    export const usePostApiV1MissionsSubMissions = <TError = ValidationProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsSubMissions>>, TError,{data: CreateSubMissionCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsSubMissions>>,
        TError,
        {data: CreateSubMissionCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsSubMissionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdApologise = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/apologise`, method: 'POST', signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdApologiseMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdApologise>>, TError,{missionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdApologise>>, TError,{missionId: string}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdApologise'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdApologise>>, {missionId: string}> = (props) => {
          const {missionId} = props ?? {};

          return  postApiV1MissionsMissionIdApologise(missionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdApologiseMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdApologise>>>
    
    export type PostApiV1MissionsMissionIdApologiseMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdApologise = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdApologise>>, TError,{missionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdApologise>>,
        TError,
        {missionId: string},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdApologiseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdMembersMembershipIdExclude = (
    missionId: string,
    membershipId: string,
    excludeMemberRequest: ExcludeMemberRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/members/${membershipId}/exclude`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: excludeMemberRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdMembersMembershipIdExcludeMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdExclude>>, TError,{missionId: string;membershipId: string;data: ExcludeMemberRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdExclude>>, TError,{missionId: string;membershipId: string;data: ExcludeMemberRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdMembersMembershipIdExclude'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdExclude>>, {missionId: string;membershipId: string;data: ExcludeMemberRequest}> = (props) => {
          const {missionId,membershipId,data} = props ?? {};

          return  postApiV1MissionsMissionIdMembersMembershipIdExclude(missionId,membershipId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdMembersMembershipIdExcludeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdExclude>>>
    export type PostApiV1MissionsMissionIdMembersMembershipIdExcludeMutationBody = ExcludeMemberRequest
    export type PostApiV1MissionsMissionIdMembersMembershipIdExcludeMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MissionsMissionIdMembersMembershipIdExclude = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdExclude>>, TError,{missionId: string;membershipId: string;data: ExcludeMemberRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembersMembershipIdExclude>>,
        TError,
        {missionId: string;membershipId: string;data: ExcludeMemberRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdMembersMembershipIdExcludeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissing = (
    reportMissingPersonCommand: ReportMissingPersonCommand,
 signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/api/v1/missions/missing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportMissingPersonCommand, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissingMutationOptions = <TError = ValidationProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissing>>, TError,{data: ReportMissingPersonCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissing>>, TError,{data: ReportMissingPersonCommand}, TContext> => {

const mutationKey = ['postApiV1MissionsMissing'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissing>>, {data: ReportMissingPersonCommand}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1MissionsMissing(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissingMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissing>>>
    export type PostApiV1MissionsMissingMutationBody = ReportMissingPersonCommand
    export type PostApiV1MissionsMissingMutationError = ValidationProblemDetails

    export const usePostApiV1MissionsMissing = <TError = ValidationProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissing>>, TError,{data: ReportMissingPersonCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissing>>,
        TError,
        {data: ReportMissingPersonCommand},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdSubmitToCommittee = (
    missionId: string,
    submitToCommitteeRequest: SubmitToCommitteeRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/submit-to-committee`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitToCommitteeRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdSubmitToCommitteeMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdSubmitToCommittee>>, TError,{missionId: string;data: SubmitToCommitteeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdSubmitToCommittee>>, TError,{missionId: string;data: SubmitToCommitteeRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdSubmitToCommittee'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdSubmitToCommittee>>, {missionId: string;data: SubmitToCommitteeRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdSubmitToCommittee(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdSubmitToCommitteeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdSubmitToCommittee>>>
    export type PostApiV1MissionsMissionIdSubmitToCommitteeMutationBody = SubmitToCommitteeRequest
    export type PostApiV1MissionsMissionIdSubmitToCommitteeMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdSubmitToCommittee = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdSubmitToCommittee>>, TError,{missionId: string;data: SubmitToCommitteeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdSubmitToCommittee>>,
        TError,
        {missionId: string;data: SubmitToCommitteeRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdSubmitToCommitteeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1MissionsCommitteeQueue = (
    params?: GetApiV1MissionsCommitteeQueueParams,
 signal?: AbortSignal
) => {
      
      
      return request<CommitteeQueueItemDtoPagedList>(
      {url: `/api/v1/missions/committee-queue`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1MissionsCommitteeQueueQueryKey = (params?: GetApiV1MissionsCommitteeQueueParams,) => {
    return [
    `/api/v1/missions/committee-queue`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1MissionsCommitteeQueueQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>, TError = unknown>(params?: GetApiV1MissionsCommitteeQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsCommitteeQueueQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>> = ({ signal }) => getApiV1MissionsCommitteeQueue(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsCommitteeQueueQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>>
export type GetApiV1MissionsCommitteeQueueQueryError = unknown


export function useGetApiV1MissionsCommitteeQueue<TData = Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>, TError = unknown>(
 params: undefined |  GetApiV1MissionsCommitteeQueueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsCommitteeQueue<TData = Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>, TError = unknown>(
 params?: GetApiV1MissionsCommitteeQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsCommitteeQueue<TData = Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>, TError = unknown>(
 params?: GetApiV1MissionsCommitteeQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsCommitteeQueue<TData = Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>, TError = unknown>(
 params?: GetApiV1MissionsCommitteeQueueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsCommitteeQueue>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsCommitteeQueueQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postApiV1MissionsMissionIdVotes = (
    missionId: string,
    castVoteRequest: CastVoteRequest,
 signal?: AbortSignal
) => {
      
      
      return request<CommitteeVoteResult>(
      {url: `/api/v1/missions/${missionId}/votes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: castVoteRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdVotesMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdVotes>>, TError,{missionId: string;data: CastVoteRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdVotes>>, TError,{missionId: string;data: CastVoteRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdVotes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdVotes>>, {missionId: string;data: CastVoteRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdVotes(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdVotesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdVotes>>>
    export type PostApiV1MissionsMissionIdVotesMutationBody = CastVoteRequest
    export type PostApiV1MissionsMissionIdVotesMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdVotes = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdVotes>>, TError,{missionId: string;data: CastVoteRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdVotes>>,
        TError,
        {missionId: string;data: CastVoteRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdVotesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdPublish = (
    missionId: string,
    publishMissionRequest: PublishMissionRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/publish`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: publishMissionRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdPublishMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdPublish>>, TError,{missionId: string;data: PublishMissionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdPublish>>, TError,{missionId: string;data: PublishMissionRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdPublish'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdPublish>>, {missionId: string;data: PublishMissionRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdPublish(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdPublishMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdPublish>>>
    export type PostApiV1MissionsMissionIdPublishMutationBody = PublishMissionRequest
    export type PostApiV1MissionsMissionIdPublishMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdPublish = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdPublish>>, TError,{missionId: string;data: PublishMissionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdPublish>>,
        TError,
        {missionId: string;data: PublishMissionRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdPublishMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdRefuse = (
    missionId: string,
    refuseMissionRequest: RefuseMissionRequest,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/refuse`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refuseMissionRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdRefuseMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRefuse>>, TError,{missionId: string;data: RefuseMissionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRefuse>>, TError,{missionId: string;data: RefuseMissionRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdRefuse'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRefuse>>, {missionId: string;data: RefuseMissionRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdRefuse(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdRefuseMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRefuse>>>
    export type PostApiV1MissionsMissionIdRefuseMutationBody = RefuseMissionRequest
    export type PostApiV1MissionsMissionIdRefuseMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MissionsMissionIdRefuse = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdRefuse>>, TError,{missionId: string;data: RefuseMissionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdRefuse>>,
        TError,
        {missionId: string;data: RefuseMissionRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdRefuseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdTrackBatch = (
    missionId: string,
    trackBatchRequest: TrackBatchRequest,
 signal?: AbortSignal
) => {
      
      
      return request<TrackBatchResult>(
      {url: `/api/v1/missions/${missionId}/track/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: trackBatchRequest, signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdTrackBatchMutationOptions = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdTrackBatch>>, TError,{missionId: string;data: TrackBatchRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdTrackBatch>>, TError,{missionId: string;data: TrackBatchRequest}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdTrackBatch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdTrackBatch>>, {missionId: string;data: TrackBatchRequest}> = (props) => {
          const {missionId,data} = props ?? {};

          return  postApiV1MissionsMissionIdTrackBatch(missionId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdTrackBatchMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdTrackBatch>>>
    export type PostApiV1MissionsMissionIdTrackBatchMutationBody = TrackBatchRequest
    export type PostApiV1MissionsMissionIdTrackBatchMutationError = ValidationProblemDetails | ProblemDetails

    export const usePostApiV1MissionsMissionIdTrackBatch = <TError = ValidationProblemDetails | ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdTrackBatch>>, TError,{missionId: string;data: TrackBatchRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdTrackBatch>>,
        TError,
        {missionId: string;data: TrackBatchRequest},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdTrackBatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const postApiV1MissionsMissionIdMembers = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/api/v1/missions/${missionId}/members`, method: 'POST', signal
    },
      );
    }
  


export const getPostApiV1MissionsMissionIdMembersMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembers>>, TError,{missionId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembers>>, TError,{missionId: string}, TContext> => {

const mutationKey = ['postApiV1MissionsMissionIdMembers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembers>>, {missionId: string}> = (props) => {
          const {missionId} = props ?? {};

          return  postApiV1MissionsMissionIdMembers(missionId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1MissionsMissionIdMembersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembers>>>
    
    export type PostApiV1MissionsMissionIdMembersMutationError = ProblemDetails

    export const usePostApiV1MissionsMissionIdMembers = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembers>>, TError,{missionId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1MissionsMissionIdMembers>>,
        TError,
        {missionId: string},
        TContext
      > => {

      const mutationOptions = getPostApiV1MissionsMissionIdMembersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getApiV1MissionsMissionIdMembers = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<MissionRosterEntryDto[]>(
      {url: `/api/v1/missions/${missionId}/members`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MissionsMissionIdMembersQueryKey = (missionId?: string,) => {
    return [
    `/api/v1/missions/${missionId}/members`
    ] as const;
    }

    
export const getGetApiV1MissionsMissionIdMembersQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>, TError = ProblemDetails>(missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMissionIdMembersQueryKey(missionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>> = ({ signal }) => getApiV1MissionsMissionIdMembers(missionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(missionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMissionIdMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>>
export type GetApiV1MissionsMissionIdMembersQueryError = ProblemDetails


export function useGetApiV1MissionsMissionIdMembers<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>, TError = ProblemDetails>(
 missionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdMembers<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdMembers<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMissionIdMembers<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdMembers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMissionIdMembersQueryOptions(missionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1MissionsMissionIdBundle = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<MissionBundleDto>(
      {url: `/api/v1/missions/${missionId}/bundle`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MissionsMissionIdBundleQueryKey = (missionId?: string,) => {
    return [
    `/api/v1/missions/${missionId}/bundle`
    ] as const;
    }

    
export const getGetApiV1MissionsMissionIdBundleQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>, TError = ProblemDetails>(missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMissionIdBundleQueryKey(missionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>> = ({ signal }) => getApiV1MissionsMissionIdBundle(missionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(missionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMissionIdBundleQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>>
export type GetApiV1MissionsMissionIdBundleQueryError = ProblemDetails


export function useGetApiV1MissionsMissionIdBundle<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>, TError = ProblemDetails>(
 missionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdBundle<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdBundle<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMissionIdBundle<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdBundle>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMissionIdBundleQueryOptions(missionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1MissionsMissionIdCoverage = (
    missionId: string,
    params?: GetApiV1MissionsMissionIdCoverageParams,
 signal?: AbortSignal
) => {
      
      
      return request<CoverageDto>(
      {url: `/api/v1/missions/${missionId}/coverage`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1MissionsMissionIdCoverageQueryKey = (missionId?: string,
    params?: GetApiV1MissionsMissionIdCoverageParams,) => {
    return [
    `/api/v1/missions/${missionId}/coverage`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1MissionsMissionIdCoverageQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>, TError = ProblemDetails>(missionId: string,
    params?: GetApiV1MissionsMissionIdCoverageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMissionIdCoverageQueryKey(missionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>> = ({ signal }) => getApiV1MissionsMissionIdCoverage(missionId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(missionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMissionIdCoverageQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>>
export type GetApiV1MissionsMissionIdCoverageQueryError = ProblemDetails


export function useGetApiV1MissionsMissionIdCoverage<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>, TError = ProblemDetails>(
 missionId: string,
    params: undefined |  GetApiV1MissionsMissionIdCoverageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdCoverage<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>, TError = ProblemDetails>(
 missionId: string,
    params?: GetApiV1MissionsMissionIdCoverageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdCoverage<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>, TError = ProblemDetails>(
 missionId: string,
    params?: GetApiV1MissionsMissionIdCoverageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMissionIdCoverage<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>, TError = ProblemDetails>(
 missionId: string,
    params?: GetApiV1MissionsMissionIdCoverageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdCoverage>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMissionIdCoverageQueryOptions(missionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getApiV1MissionsMissionIdPositions = (
    missionId: string,
 signal?: AbortSignal
) => {
      
      
      return request<MemberPositionDto[]>(
      {url: `/api/v1/missions/${missionId}/positions`, method: 'GET', signal
    },
      );
    }
  



export const getGetApiV1MissionsMissionIdPositionsQueryKey = (missionId?: string,) => {
    return [
    `/api/v1/missions/${missionId}/positions`
    ] as const;
    }

    
export const getGetApiV1MissionsMissionIdPositionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>, TError = ProblemDetails>(missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1MissionsMissionIdPositionsQueryKey(missionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>> = ({ signal }) => getApiV1MissionsMissionIdPositions(missionId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(missionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1MissionsMissionIdPositionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>>
export type GetApiV1MissionsMissionIdPositionsQueryError = ProblemDetails


export function useGetApiV1MissionsMissionIdPositions<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>, TError = ProblemDetails>(
 missionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdPositions<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>,
          TError,
          Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1MissionsMissionIdPositions<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1MissionsMissionIdPositions<TData = Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>, TError = ProblemDetails>(
 missionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1MissionsMissionIdPositions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1MissionsMissionIdPositionsQueryOptions(missionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




